import { useTranslation } from 'react-i18next';
import { BackArrow, IconButton } from 'qampo-ui-library';
import { Button } from '../../UI/base/Button';
import type { SaveStatus } from './saveStatus';
import styles from '../../../pages/TreatmentPlanBuilderPage.module.css';

interface BuilderTopBarProps {
  templateName: string;
  saveStatus: SaveStatus;
  onBack: () => void;
  // May return a promise: Button auto-disables until a returned promise settles.
  onSave: () => unknown;
}

export const BuilderTopBar = ({
  templateName,
  saveStatus,
  onBack,
  onSave
}: BuilderTopBarProps) => {
  const { t } = useTranslation();

  const saveStatusClassName = `${styles.saveStatus} ${
    saveStatus === 'unsaved' ? styles.saveStatusDirty : styles.saveStatusSaved
  }`;

  return (
    <div className={styles.topBar}>
      <nav className={styles.breadcrumbRow} aria-label="Breadcrumb">
        <IconButton icon={<BackArrow />} onClick={onBack} />
        <div className={styles.breadcrumbStack}>
          <button type="button" className={styles.breadcrumbLink} onClick={onBack}>
            {t('configuration')}
          </button>
          <span className={styles.breadcrumbCurrent}>
            {templateName || t('config-unnamed-template')}
          </span>
        </div>
      </nav>
      <div className={styles.topBarActions}>
        {saveStatus !== 'none' && (
          <output className={saveStatusClassName}>
            <span className={styles.saveStatusDot} aria-hidden="true" />
            {saveStatus === 'unsaved' ? t('config-builder-unsaved') : t('config-builder-all-saved')}
          </output>
        )}
        <Button type="secondary" onClick={onBack}>
          {t('config-builder-cancel')}
        </Button>
        <Button type="primary" onClick={onSave}>
          {t('config-builder-save')}
        </Button>
      </div>
    </div>
  );
};
